/* eslint-disable jsx-a11y/anchor-is-valid */

import { FC, useEffect, useMemo, useRef, useState } from 'react'
import {
  AsoType,
  AtendimentoEstado,
  AtendimentoType,
  ButtonType,
  ContratoType,
  EnvioType,
  mapEnderecosToOptions,
  MaskType,
  ModalidadeType,
  OptionsHelper,
  QueryState,
  showAlert,
  showConfirmAlert,
  showError,
  stringifyRequestQuery,
} from '../../../../../../../_metronic/helpers'
import {
  Button,
  FetchState,
  FormDateTimeInput,
  FormInput,
  FormRadio,
  FormSelect,
  FormToggle,
  IOption,
  IRadioOption,
  ListLoading,
  LoadingIndicator,
  useModal,
} from '../../../../../../components'
import { AtendimentoDto, AtendimentoDtoCreate, AtendimentoDtoDadosAso } from '../../../core/_models'
import { EmpresaView, EnderecoList } from '../../../../empresa/empresas-list/core/_models'
import {
  getEmpresaById,
  getModalidadesByEmpresa,
} from '../../../../empresa/empresas-list/core/_requests'
import {
  agendaAtendimento,
  alteraAtendimentoASO,
  getAtendimentosByPaciente,
  getEnderecosByAtendimento,
} from '../../../core/_requests'
import { useFormik } from 'formik'
import { getColaboradoresOfEmpresaCliente } from '../../../../empresa/empresasClienteCoordenador-list/core/_request'
import { getSetoresCliente } from '../../../../empresa/empresasClienteSetor-list/core/_request'
import { getCargosCliente } from '../../../../empresa/empresasClienteCargo-list/core/_request'
import { ExamesModal } from '../../../../atendimento-ASO/components/modal'
import { newAtendimentoSchema } from './validation/newAtendimentoSchema'
import { PacienteView } from '../../../../paciente-management/pacientes-list/core/_models'
import {
  getUnidadeEnderecoAtendimento,
  getUnidades,
} from '../../../../unidades/unidades-list/core/_requests'
import { useT } from '_metronic/i18n/Metronici18n'

const SectionHeader: FC<{ title: string; className?: string }> = ({ title, className = '' }) => (
  <div className={`d-flex align-items-center mb-4 ${className}`}>
    <span className='bullet bullet-vertical h-20px bg-violet me-3' />
    <h3 className='fs-6 fw-bold text-gray-800 mb-0'>{title}</h3>
  </div>
)

export const NewAtendimentoModal: FC = () => {
  const { closeModal, fetchStates } = useModal()
  const { t } = useT()
  const lastFetchRef = useRef<{
    modalidade: ModalidadeType | undefined
    unidade: number | undefined
    cliente: number | undefined
  }>({
    modalidade: undefined,
    unidade: undefined,
    cliente: undefined,
  })

  const { data: paciente } = (fetchStates['paciente'] || {}) as FetchState<PacienteView>

  const [atendimento, setAtendimento] = useState<AtendimentoDto>()
  const [empresaPaciente, setEmpresaPaciente] = useState<EmpresaView>()
  const [optionsResponsavel, setOptionsResponsavel] = useState<IOption<number>[]>([])
  const [optionsTiposAtendimento, setOptionsTiposAtendimento] = useState<
    IOption<AtendimentoType>[]
  >([])
  const [optionsCargos, setOptionsCargos] = useState<IOption<number>[]>([])
  const [optionsSetores, setOptionsSetores] = useState<IOption<number>[]>([])
  const [optionsUnidades, setOptionsUnidades] = useState<IOption<number>[]>([])
  const [optionsModalidades, setOptionsModalidades] = useState<IOption<ModalidadeType>[]>([])

  const [showEndereco, setShowEndereco] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [hasSubmited, setHasSubmited] = useState<boolean>(false)

  const addInfoAtendimentoASO = (atendimentoIniciado: AtendimentoDto) => {
    try {
      let matricula =
        atendimentoIniciado?.dadosAso?.matricula !== undefined
          ? atendimentoIniciado?.dadosAso?.matricula
          : ''

      const atendimento: AtendimentoDtoDadosAso = {
        cargo: formik.values.cargo?.label as string,
        setor: formik.values.setor?.label as string,
        cargoAso: formik.values.cargo?.value,
        setorAso: formik.values.setor?.value,
        matricula,
      }

      alteraAtendimentoASO(atendimentoIniciado?.id, atendimento)
    } catch (error) {
      showError(error)
    }
  }

  const initialValues = {
    tipoAtendimento: undefined as IOption<AtendimentoType> | undefined,
    modalidade: undefined as IOption<ModalidadeType> | undefined,
    especialidade: undefined as IOption<number> | undefined,
    unidade: undefined as IOption<number> | undefined,
    tipoAso: undefined as IOption<AsoType> | undefined,
    cliente: undefined as IOption<number> | undefined,
    setor: null as IOption<number> | null,
    cargo: null as IOption<number> | null,
    responsavel: null as IOption<number> | null,
    dataAtendimento: '',
    retorno: false,
    shouldSend: false,
    email: '',
    telefone: '',
    enderecoId: '',
    optionsEnderecos: [] as IRadioOption[],
    endereco: {
      nome: '',
      cep: '',
      logradouro: '',
      numero: '',
      complemento: '',
      bairro: '',
      cidade: '',
      uf: undefined as IOption<string> | undefined,
    },
  }

  const formik = useFormik({
    validationSchema: newAtendimentoSchema(showEndereco),
    initialValues,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        if (paciente) {
          const state: QueryState = {
            page: 0,
            size: 10,
            search: `estado:${AtendimentoEstado.Aguardando}|${
              AtendimentoEstado.EmAtendimento
            },tipo:${values.tipoAtendimento?.value}${
              values.tipoAtendimento?.value !== AtendimentoType.Ocupacional &&
              values.tipoAtendimento?.value !== AtendimentoType.Screening &&
              values.tipoAtendimento?.value !== AtendimentoType.Telekit
                ? `,especialidade:${values.especialidade?.value}`
                : ''
            }`,
          }
          const resp = await getAtendimentosByPaciente(paciente.id, stringifyRequestQuery(state))

          if (resp.data && resp.data.length > 0) {
            const html = `
<div>
  <p style="margin-bottom: 8px">
    O paciente já possui os seguintes atendimentos:
  </p>
  ${resp.data
    .map(
      (atend) => `
        <div style="
          margin-bottom:8px;
          padding:6px 10px;
          border-left:3px solid var(--bs-info-active);
          background-color: var(--bs-light);
          border-radius:4px;
          color: var(--bs-body-color);
        ">
          ${atend.especialidade?.nome ?? 'Sem especialidade'} - ${atend.solicitacaoFormatada}
        </div>
          `
    )
    .join('')}
  </div>
                  `
            const isConfirmed = await showConfirmAlert({
              html,
              text: 'Você gostaria criar um novo atendimento?',
              confirmButtonText: 'Sim',
            })
            if (!isConfirmed) return
          }
          const dataAtendimento = (String(values.dataAtendimento) + ':00').replace('T', ' ')

          const newAtendimento: AtendimentoDtoCreate = {
            tipo: values.tipoAtendimento?.value as AtendimentoType,
            cliente: values.cliente?.value,
            especialidade: values.especialidade?.value,
            unidade: values.unidade?.value,
            pcmso: values.responsavel?.value,
            retorno: values.retorno,
            tipoAso: values.tipoAso?.value,
            data: dataAtendimento,
            modalidade: values.modalidade?.value as ModalidadeType,
            endereco:
              values.modalidade?.value !== ModalidadeType.Presencial
                ? undefined
                : showEndereco
                ? {
                    novo: {
                      cep: values.endereco.cep,
                      logradouro: values.endereco.logradouro,
                      numero: values.endereco.numero,
                      complemento: values.endereco.complemento || undefined,
                      bairro: values.endereco.bairro,
                      cidade: values.endereco.cidade,
                      uf: values.endereco.uf?.value as string,
                      nome: values.endereco.nome,
                    },
                  }
                : { id: Number(values.enderecoId) },
            dadosPaciente: values.shouldSend
              ? {
                  tipoEnvio: EnvioType.Ambos,
                  email: values.email || undefined,
                  telefone: values.telefone || undefined,
                }
              : undefined,
          }
          const atendimentoCriado = await agendaAtendimento(paciente.id, newAtendimento)

          setAtendimento(atendimentoCriado)
          if (values.tipoAtendimento?.value === AtendimentoType.Ocupacional) {
            addInfoAtendimentoASO(atendimentoCriado)
          }
          showAlert({ title: 'Sucesso!', text: 'Atendimento criado com sucesso!', icon: 'success' })

          setHasSubmited(true)
        }
      } catch (error) {
        showError(error)
      } finally {
        setSubmitting(false)
      }
    },
  })
  // `setFieldValue` é `useEventCallback` no formik: identidade estável entre renders.
  const { setFieldValue } = formik
  const clienteId = formik.values.cliente?.value
  const modalidadeValue = formik.values.modalidade?.value
  const unidadeId = formik.values.unidade?.value
  const empresaPacienteId = empresaPaciente?.id

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (paciente) {
          setFieldValue('email', paciente.pessoa.usuario?.email || '')
          setFieldValue('telefone', paciente.pessoa.telefone || '')
          const empresa = await getEmpresaById(paciente?.empresa?.id)
          const resp = await getUnidades(`page=0&size=200&search=&idEmpresa=${empresa.id}`)
          const modalidades = await getModalidadesByEmpresa(Number(paciente?.empresa.id))
          setOptionsUnidades(OptionsHelper.createOptions(resp.data || [], 'nome', 'id'))
          setEmpresaPaciente(empresa)

          const filtered = empresa?.tiposAtendimentoMap?.filter(
            (tipo) => tipo.name !== AtendimentoType.Interconsulta
          )

          const filteredModalides = modalidades?.filter(
            (modalidade) => modalidade.name !== ModalidadeType.Parecer
          )

          setOptionsTiposAtendimento(
            OptionsHelper.createOptions(filtered || [], 'descricao', 'name')
          )
          setOptionsModalidades(
            OptionsHelper.createOptions(filteredModalides || [], 'descricao', 'name')
          )
        }
      } catch (error) {
        showError(error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchData()
  }, [paciente, setFieldValue])

  useEffect(() => {
    if (!clienteId || clienteId === lastFetchRef.current.cliente) return

    const fetchResponsavel = async () => {
      setIsLoading(true)
      setFieldValue('responsavel', null, false)
      setFieldValue('setor', null, false)
      setFieldValue('cargo', null, false)
      try {
        const responsaveis = await getColaboradoresOfEmpresaCliente(Number(clienteId))
        const { data: setores } = await getSetoresCliente(
          empresaPacienteId,
          'page=0&size=100&search=cliente:' + Number(clienteId)
        )
        const { data: cargos } = await getCargosCliente(
          empresaPacienteId,
          'page=0&size=100&search=cliente:' + Number(clienteId)
        )

        setOptionsCargos(OptionsHelper.createOptions(cargos || [], 'nome', 'id'))
        setOptionsSetores(OptionsHelper.createOptions(setores || [], 'nome', 'id'))
        setOptionsResponsavel(OptionsHelper.createOptions(responsaveis || [], 'nome', 'id'))
      } catch (error) {
        showError(error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchResponsavel()
    lastFetchRef.current.cliente = clienteId
  }, [clienteId, empresaPacienteId, setFieldValue])

  useEffect(() => {
    const isPresencial = modalidadeValue === ModalidadeType.Presencial

    if (
      lastFetchRef.current.modalidade === modalidadeValue &&
      lastFetchRef.current.unidade === unidadeId
    ) {
      return // nada mudou, não faz fetch
    }

    lastFetchRef.current = {
      modalidade: modalidadeValue,
      unidade: unidadeId,
      cliente: clienteId,
    }

    const fetchEnderecos = async () => {
      setIsLoading(true)
      try {
        if (!isPresencial) {
          setFieldValue('optionsEnderecos', [])
          setShowEndereco(false)
          return
        }

        let enderecos: EnderecoList[] = []
        if (unidadeId != null) {
          enderecos = await getUnidadeEnderecoAtendimento(unidadeId)
        } else if (empresaPacienteId) {
          enderecos = await getEnderecosByAtendimento(Number(empresaPacienteId))
        }

        const options = mapEnderecosToOptions(enderecos)
        setShowEndereco(options.length === 0)
        setFieldValue('optionsEnderecos', options)
      } catch (err) {
        showError(err)
      } finally {
        setIsLoading(false)
      }
    }

    fetchEnderecos()
  }, [modalidadeValue, unidadeId, clienteId, empresaPacienteId, setFieldValue])

  const extraParams = useMemo(
    () => ({
      pacienteId: paciente?.id,
      tipo: formik.values.tipoAtendimento?.value,
      unidadeId: formik.values.unidade?.value,
    }),
    [paciente?.id, formik.values.tipoAtendimento, formik.values.unidade]
  )

  const mostraEspecialidade =
    formik.values.tipoAtendimento &&
    formik.values.tipoAtendimento?.value !== AtendimentoType.Ocupacional &&
    formik.values.tipoAtendimento?.value !== AtendimentoType.Screening &&
    formik.values.tipoAtendimento?.value !== AtendimentoType.Telekit

  const isPresencial = formik.values.modalidade?.value === ModalidadeType.Presencial

  return (
    <>
      <form onSubmit={formik.handleSubmit} noValidate>
        {paciente && (
          <>
            <SectionHeader title={t('paciente.label')} />
            <div className='row border rounded p-3 mb-6 mx-0'>
              <div className='col-md-4'>
                <div className='text-muted fs-8 text-uppercase'>{t('nome.label')}</div>
                <div
                  className='fw-bold fs-6 text-gray-800 text-truncate'
                  title={paciente.pessoa?.nome}
                >
                  {paciente.pessoa?.nome || '-'}
                </div>
              </div>
              <div className='col-md-4'>
                <div className='text-muted fs-8 text-uppercase'>{t('empresa.label')}</div>
                <div
                  className='fw-bold fs-6 text-gray-800 text-truncate'
                  title={paciente.empresa?.nomeFantasia}
                >
                  {paciente.empresa?.nomeFantasia || '-'}
                </div>
              </div>
              <div className='col-md-4'>
                <div className='text-muted fs-8 text-uppercase'>{t('documento.label')}</div>
                <div className='fw-bold fs-6 text-gray-800 text-truncate'>
                  {paciente.pessoa?.cpf || '-'}
                </div>
              </div>
            </div>
          </>
        )}
        {!hasSubmited && (
          <>
            <SectionHeader title='Dados do atendimento' />
            <div className='border rounded p-6 mb-6'>
              {optionsUnidades && optionsUnidades.length > 0 && (
                <FormSelect
                  formik={formik}
                  options={optionsUnidades}
                  name='unidade'
                  entity='unidade_setor'
                  isDisabled={hasSubmited || formik.isSubmitting}
                  className='mb-3'
                />
              )}
              <div className='row'>
                <div className={mostraEspecialidade ? 'col-md-6' : 'col-12'}>
                  <FormSelect
                    formik={formik}
                    options={optionsTiposAtendimento}
                    name='tipoAtendimento'
                    entity='tipoAtendimento'
                    isRequired={true}
                    isDisabled={hasSubmited || formik.isSubmitting}
                    onChange={() => formik.setFieldValue('especialidade', null)}
                    isClearable={false}
                    className='mb-3'
                  />
                </div>
                {mostraEspecialidade && (
                  <div className='col-md-6'>
                    <FormSelect
                      formik={formik}
                      fetchOptions={OptionsHelper.getOptionsEspecialidadesByPaciente}
                      name='especialidade'
                      entity='especialidade'
                      isRequired={true}
                      isDisabled={hasSubmited || formik.isSubmitting}
                      fetchOptionsParams={extraParams}
                      isClearable={false}
                      className='mb-3'
                    />
                  </div>
                )}
              </div>
              <div className='row'>
                <div className='col-md-6'>
                  <FormDateTimeInput
                    formik={formik}
                    name='dataAtendimento'
                    entity='data_atendimento'
                    isDisabled={hasSubmited || formik.isSubmitting}
                    min={new Date()}
                    isRequired
                  />
                </div>
                <div className='col-md-6'>
                  <FormSelect
                    formik={formik}
                    options={optionsModalidades}
                    name='modalidade'
                    entity='modalidade'
                    isDisabled={hasSubmited || formik.isSubmitting}
                    isClearable={false}
                    isRequired
                  />
                </div>
              </div>

              {paciente?.empresa?.tiposContrato?.some(
                (contrato) => contrato === ContratoType.Retorno
              ) &&
                formik.values.tipoAtendimento &&
                formik.values.tipoAtendimento?.value !== AtendimentoType.Ocupacional && (
                  <FormToggle
                    formik={formik}
                    name='retorno'
                    label='Consulta de retorno?'
                    className='mt-3 mb-0'
                    isDisabled={hasSubmited || formik.isSubmitting}
                  />
                )}
            </div>
            {isPresencial && (
              <>
                <SectionHeader title='Endereço de atendimento' />
                <div className='border rounded p-6 mb-6'>
                  {formik.values.optionsEnderecos.length > 0 && (
                    <FormRadio
                      formik={formik}
                      name='enderecoId'
                      options={formik.values.optionsEnderecos}
                      isColumn
                      className='mb-3'
                    />
                  )}
                  <div className='d-flex justify-content-end'>
                    <Button
                      className={`btn-primary ${showEndereco ? 'mb-6' : ''}`}
                      onClick={() => setShowEndereco((prev) => !prev)}
                      size='btn-sm'
                      disabled={
                        formik.isSubmitting ||
                        isLoading ||
                        formik.values.optionsEnderecos.length === 0
                      }
                    >
                      {showEndereco ? 'Remover Endereço' : 'Criar Endereço'}
                    </Button>
                  </div>
                  {showEndereco && (
                    <div className='border-top pt-4'>
                      <h4 className='fs-7 fw-bold text-gray-700 text-uppercase mb-4'>
                        Novo Endereço
                      </h4>
                      <FormInput
                        formik={formik}
                        label='Nome do Endereço'
                        name='endereco.nome'
                        placeholder='Digite o nome do endereço'
                        isRequired
                        className='mb-3'
                      />
                      <div className='row mb-3'>
                        <div className='col-md-8'>
                          <FormInput
                            formik={formik}
                            entity='logradouro'
                            name='endereco.logradouro'
                            isRequired
                          />
                        </div>
                        <div className='col-md-4'>
                          <FormInput
                            formik={formik}
                            entity='numero'
                            name='endereco.numero'
                            isRequired
                          />
                        </div>
                      </div>
                      <div className='row mb-3'>
                        <div className='col-md-8'>
                          <FormInput
                            formik={formik}
                            entity='complemento'
                            name='endereco.complemento'
                          />
                        </div>
                        <div className='col-md-4'>
                          <FormInput
                            formik={formik}
                            entity='cep'
                            name='endereco.cep'
                            mask={MaskType.CEP}
                            isRequired
                          />
                        </div>
                      </div>
                      <div className='row mb-3'>
                        <div className='col-md-8'>
                          <FormInput
                            formik={formik}
                            entity='bairro'
                            name='endereco.bairro'
                            isRequired
                          />
                        </div>
                        <div className='col-md-4'>
                          <FormInput
                            formik={formik}
                            entity='cidade'
                            name='endereco.cidade'
                            isRequired
                          />
                        </div>
                      </div>

                      <FormSelect
                        formik={formik}
                        entity='estado'
                        name='endereco.uf'
                        fetchOptions={OptionsHelper.getOptionsEstadosUf}
                        isClearable={false}
                        isRequired
                      />
                    </div>
                  )}
                </div>
              </>
            )}
            {formik.values.tipoAtendimento?.value === AtendimentoType.Ocupacional && (
              <>
                <SectionHeader title='Dados do ASO / PCMSO' />
                <div className='border rounded p-6 mb-6'>
                  <div className='row'>
                    <div className='col-md-6'>
                      <FormSelect
                        formik={formik}
                        name='tipoAso'
                        label='Tipo Aso'
                        placeholder='Selecione o tipo de Aso'
                        isDisabled={hasSubmited || formik.isSubmitting}
                        fetchOptions={OptionsHelper.getOptionsTiposAso}
                        isRequired={true}
                        isClearable={false}
                        className='mb-3'
                      />
                    </div>
                    <div className='col-md-6'>
                      <FormSelect
                        formik={formik}
                        name='cliente'
                        label='Empregador Aso'
                        placeholder='Selecione um empregador Aso'
                        isDisabled={hasSubmited || formik.isSubmitting}
                        fetchOptions={OptionsHelper.getOptionsEmpresasCliente}
                        fetchOptionsParams={{ idEmpresa: empresaPaciente?.id }}
                        isRequired={true}
                        isClearable={false}
                        className='mb-3'
                      />
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-md-4'>
                      <FormSelect
                        formik={formik}
                        name='responsavel'
                        label='Responsável Pcmso'
                        placeholder='Selecione um responsável'
                        isDisabled={hasSubmited || formik.isSubmitting}
                        options={optionsResponsavel}
                        isRequired={true}
                        isClearable={false}
                        className='mb-3 mb-md-0'
                      />
                    </div>
                    <div className='col-md-4'>
                      <FormSelect
                        formik={formik}
                        name='setor'
                        entity='setor'
                        isDisabled={hasSubmited || formik.isSubmitting}
                        options={optionsSetores}
                        isRequired={true}
                        isClearable={false}
                        className='mb-3 mb-md-0'
                      />
                    </div>
                    <div className='col-md-4'>
                      <FormSelect
                        formik={formik}
                        name='cargo'
                        entity='cargo'
                        isDisabled={hasSubmited || formik.isSubmitting}
                        options={optionsCargos}
                        isRequired={true}
                        isClearable={false}
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
            {paciente?.empresa?.tiposContrato?.some(
              (contrato) => contrato === ContratoType.Link_Celular
            ) && (
              <>
                <SectionHeader title='Contato do paciente' />
                <div className='border rounded p-6 mb-6'>
                  <FormToggle
                    formik={formik}
                    name='shouldSend'
                    label='Você gostaria de enviar para o paciente?'
                    className={formik.values.shouldSend ? 'mb-3' : 'mb-0'}
                    isDisabled={hasSubmited || formik.isSubmitting}
                  />
                  {formik.values.shouldSend && (
                    <div className='row'>
                      <div className='col-md-6'>
                        <FormInput formik={formik} name='email' entity='email' />
                      </div>
                      <div className='col-md-6'>
                        <FormInput
                          formik={formik}
                          name='telefone'
                          entity='telefone'
                          mask={MaskType.Phone}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </>
            )}
          </>
        )}
        {formik.isSubmitting && atendimento === undefined && (
          <div className='alert alert-primary d-flex align-items-center mb-6'>
            <span className='spinner-border spinner-border-sm align-middle me-3' />
            <div className='alert-text'>Por favor aguarde o seu protocolo de atendimento</div>
          </div>
        )}
        {!formik.isSubmitting && atendimento !== undefined && (
          <div className='alert alert-success mb-6'>
            <div className='alert-text fw-bold mb-1'>Atendimento solicitado com sucesso!</div>
            <div className='alert-text mb-5'>Acesse a lista de atendimentos para acompanhá-lo.</div>
            <div className='row'>
              <div className='col-md-4 mb-3'>
                <div className='fs-8 text-uppercase'>{t('protocolo.label')}</div>
                <div className='fw-bold fs-6'>{atendimento?.protocolo || '-'}</div>
              </div>
              <div className='col-md-4 mb-3'>
                <div className='fs-8 text-uppercase'>{t('estado.label')}</div>
                <div className='fw-bold fs-6'>{atendimento?.estado?.descricao || '-'}</div>
              </div>
              <div className='col-md-4 mb-3'>
                <div className='fs-8 text-uppercase'>{t('data.label')}</div>
                <div className='fw-bold fs-6'>{atendimento?.solicitacaoFormatada || '-'}</div>
              </div>
              <div className='col-md-4 mb-3'>
                <div className='fs-8 text-uppercase'>{t('empresa.label')}</div>
                <div className='fw-bold fs-6'>{paciente?.empresa?.nomeFantasia || '-'}</div>
              </div>
              {optionsUnidades.length > 0 && (
                <div className='col-md-4 mb-3'>
                  <div className='fs-8 text-uppercase'>{t('unidade.label')}</div>
                  <div className='fw-bold fs-6'>{formik.values.unidade?.label || '-'}</div>
                </div>
              )}
              <div className='col-md-4 mb-3'>
                <div className='fs-8 text-uppercase'>{t('tipoAtendimento.label')}</div>
                <div className='fw-bold fs-6'>{formik.values.tipoAtendimento?.label || '-'}</div>
              </div>
              {mostraEspecialidade && (
                <div className='col-md-4 mb-3'>
                  <div className='fs-8 text-uppercase'>{t('especialidade.label')}</div>
                  <div className='fw-bold fs-6'>{atendimento?.especialidade?.nome || '-'}</div>
                </div>
              )}
              <div className='col-md-4 mb-3'>
                <div className='fs-8 text-uppercase'>{t('modalidade.label')}</div>
                <div className='fw-bold fs-6'>{formik.values.modalidade?.label || '-'}</div>
              </div>
            </div>
          </div>
        )}
        {!hasSubmited && (
          <div className='d-flex justify-content-between align-items-center border-top pt-6'>
            <span className='fs-8 text-muted'>
              <span className='text-danger'>*</span> Campos obrigatórios
            </span>
            <div className='d-flex justify-content-end'>
              <Button
                type={ButtonType.Reset}
                className='btn-secondary me-3'
                onClick={closeModal}
                disabled={isLoading}
              >
                {t('common.cancel')}
              </Button>
              <Button type={ButtonType.Submit} className='btn-primary' disabled={isLoading}>
                {formik.isSubmitting ? <LoadingIndicator /> : 'Solicitar Atendimento'}
              </Button>
            </div>
          </div>
        )}

        {isLoading && <ListLoading />}
      </form>
      {hasSubmited && <ExamesModal atendimentoId={atendimento?.id} />}
    </>
  )
}
